// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3Aou3","title":"AfterFrontImage_title__10uLQ"};